import { render, staticRenderFns } from "./learnType.vue?vue&type=template&id=1d30eae7&scoped=true&"
import script from "./learnType.vue?vue&type=script&lang=js&"
export * from "./learnType.vue?vue&type=script&lang=js&"
import style0 from "./learnType.vue?vue&type=style&index=0&id=1d30eae7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d30eae7",
  null
  
)

export default component.exports